// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var InvoiceEmailEditController = function ($scope, $rootScope, $routeParams, DocumentEmailTemplate, EmailTemplatePlaceholder, gettext, gettextCatalog) {
    EmailEditControllerBase('Invoice', $scope, $rootScope, $routeParams, DocumentEmailTemplate, EmailTemplatePlaceholder, gettext, gettextCatalog);
};
InvoiceEmailEditController.$inject = ['$scope', '$rootScope', '$routeParams', 'DocumentEmailTemplate', 'EmailTemplatePlaceholder', 'gettext', 'gettextCatalog'];
